<template>
  <ul-page higher :fullHeader="false" class="page-virtual-home">
    <template v-slot:right>
      <div class="page-header-right">
        <LoginUser></LoginUser>
      </div>
    </template>
    <div class="page-top">
      <div class="page-top-shadow">
        <div class="content">
          <div class="cover">
            <img :src="virtual.cover || homePage" />
          </div>
          <div class="detail">
            <div class="title" :title="virtual.title">{{ virtual.title }}</div>
            <div class="teacher">
              <span>{{
                $t("pages_experimentPage_index_617", {
                  var0: virtual.courseTeacherName,
                })
              }}</span>
              <span>{{
                $t("pages_experimentPage_index_618", {
                  var0: virtual.studytime,
                })
              }}</span>
            </div>
            <div class="teacher">
              <span>{{
                $t("pages_experimentPage_index_619", {
                  var0: virtual.courseName,
                })
              }}</span>
            </div>
            <ul class="info-list">
              <li>
                <div class="value">{{ virtual.pageView || 0 }}</div>
                <div class="label">
                  <i class="iconfont icon-pageviews_stroke"></i
                  ><span>{{ $t("pages_experimentPage_index_620") }}</span>
                </div>
              </li>
              <li>
                <div class="value">{{ virtual.experimentTimes || 0 }}</div>
                <div class="label">
                  <i class="iconfont icon-person-times_stroke"></i
                  ><span>{{ $t("pages_experimentPage_index_621") }}</span>
                </div>
              </li>
              <li>
                <div class="value">{{ virtual.experimentPeoples || 0 }}</div>
                <div class="label">
                  <i class="iconfont icon-person-number_stroke"></i
                  ><span>{{ $t("pages_experimentPage_index_622") }}</span>
                </div>
              </li>
              <li>
                <div class="value">{{ virtual.averageTime | duration }}</div>
                <div class="label">
                  <i class="iconfont icon-xunifangzhen_shiyanleijiyongshi"></i
                  ><span>{{ $t("pages_experimentPage_index_623") }}</span>
                </div>
              </li>
              <li>
                <div class="value">{{ virtual.passRate || 0 }}%</div>
                <div class="label">
                  <i class="iconfont icon-pass-rate_stroke"></i
                  ><span>{{ $t("pages_experimentPage_index_624") }}</span>
                </div>
              </li>
            </ul>
            <div class="bt-wrapper">
              <ul-button
                type="primary"
                icon="icon-xunifangzhen_shiyancishu"
                @click="startTest"
                >{{ $t("pages_experimentPage_index_625") }}</ul-button
              >
            </div>
          </div>
        </div>
        <div class="course-study">
          <div class="course-study-left">
            <img :src="virtual.courseCover || homePage" />
            <div class="course-study-info">
              <div class="name">
                <span class="tag">{{
                  $t("pages_experimentPage_index_626")
                }}</span>
                <span class="courseName">{{ virtual.courseName }}</span>
              </div>
              <div class="tea">
                <span>{{
                  $t("pages_experimentPage_index_627", {
                    var0: virtual.courseTeacherName,
                  })
                }}</span>
                <span>{{
                  $t("pages_experimentPage_index_628", {
                    var0: virtual.courseStudytime,
                  })
                }}</span>
                <span>{{
                  $t("pages_experimentPage_index_629", {
                    var0: virtual.courseOrgan,
                  })
                }}</span>
                <span>{{
                  $t("pages_experimentPage_index_630", {
                    var0: virtual.courseSpeciality,
                  })
                }}</span>
              </div>
            </div>
          </div>
          <div>
            <ul-button size="small" hollow @click="goCourse">{{
              $t("pages_experimentPage_index_631")
            }}</ul-button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="tabs-wrapper">
        <div class="tabs">
          <div
            class="tab"
            :class="{ 'is-active': tabIndex === 0 }"
            @click="tabChange(0)"
          >
            {{ $t("pages_experimentPage_index_632") }}
          </div>
          <div
            class="tab"
            :class="{ 'is-active': tabIndex === 1 }"
            @click="tabChange(1)"
          >
            {{ $t("pages_experimentPage_index_633") }}
          </div>
        </div>
      </div>
      <div class="tab-content" v-show="tabIndex === 0">
        <div class="virtual-item" v-if="virtual.teachTarget">
          <div class="title">{{ $t("pages_experimentPage_index_634") }}</div>
          <richtext :content="virtual.teachTarget"></richtext>
        </div>
        <div class="virtual-item" v-if="virtual.principle">
          <div class="title">{{ $t("pages_experimentPage_index_635") }}</div>
          <richtext :content="virtual.principle"></richtext>
        </div>
        <div class="virtual-item" v-if="virtual.processAndMethod">
          <div class="title">{{ $t("pages_experimentPage_index_636") }}</div>
          <richtext :content="virtual.processAndMethod"></richtext>
        </div>
        <div class="virtual-item" v-if="virtual.step">
          <div class="title">{{ $t("pages_experimentPage_index_637") }}</div>
          <richtext :content="virtual.step"></richtext>
        </div>
        <div class="virtual-item" v-if="virtual.resultAndConclusion">
          <div class="title">{{ $t("pages_experimentPage_index_638") }}</div>
          <richtext :content="virtual.resultAndConclusion"></richtext>
        </div>
      </div>
      <div class="tab-content" v-show="tabIndex === 1">
        <div class="virtual-item" v-if="virtual.networkRequire">
          <div class="title">{{ $t("pages_experimentPage_index_639") }}</div>
          <richtext :content="virtual.networkRequire"></richtext>
        </div>
        <div class="virtual-item" v-if="virtual.hardwareRequire">
          <div class="title">{{ $t("pages_experimentPage_index_640") }}</div>
          <richtext :content="virtual.hardwareRequire"></richtext>
        </div>
        <div class="virtual-item" v-if="virtual.operateSystemRequire">
          <div class="title">{{ $t("pages_experimentPage_index_641") }}</div>
          <richtext :content="virtual.operateSystemRequire"></richtext>
        </div>
      </div>
    </div>
  </ul-page>
</template>

<script>
import LoginUser from "pc/components/page/user";
import { mapGetters } from "vuex";
import {
  getVirtualExperimentUrl,
  getExperimentDetails,
  updateVirtualHomeViewTimes,
} from "@/api/courseApi/virtual.js";
import cookies from "@/utils/cookie";
import Confirm from "pc/components/confirm";
import homePage from "@/assets/images/virtual/homePage.png";
import { formatSeconds } from "@/utils";
import Richtext from "pc/components/richtext.vue";

export default {
  name: "page-virtual-home",
  data() {
    return {
      homePage,
      tabIndex: 0,
      virtual: {},
    };
  },
  computed: {
    ...mapGetters({ user: "user/user", org: "org/org" }),
    experimentId() {
      return this.$route.params.id;
    },
  },
  created() {
    window.virtual = this;
    this.getVirtualDetail();
  },
  mounted() {
    this.updateViewTimes();
  },
  methods: {
    goCourse() {
      window.open(`#/virtual/coursePage/${this.virtual.courseId}`);
    },
    getVirtualDetail() {
      getExperimentDetails({ experimentId: this.experimentId }).then(
        ({ result }) => {
          document.title = result.title;
          this.virtual = result;
        }
      );
    },
    updateViewTimes() {
      updateVirtualHomeViewTimes({ experimentId: this.experimentId });
    },
    tabChange(index) {
      this.tabIndex = index;
    },
    startTest() {
      if (this.user.userId) {
        if (this.user.role == 8) {
          // 当前登录的是教师帐号，请切换到学生模式再加入课程！
          Confirm({
            content: this.$t("pages_experimentPage_index_642"),
            confirmText: this.$t("pages_experimentPage_index_643"),
            onConfirm: this.switchRole,
          });
        } else if (this.user.role == 9) {
          getVirtualExperimentUrl({ experimentId: this.experimentId }).then(
            ({ result }) => {
              window.open(result);
            }
          );
        }
      } else {
        this.toLogin();
      }
    },
    switchRole() {
      this.user.switchRole();
    },
    logout() {
      this.user.logout();
    },
    toLogin() {
      cookies.set("loginRedirectUrl", location.href);
      this.$router.push({
        path: "/login",
      });
    },
  },
  filters: {
    duration(time) {
      if (time === undefined) {
        return "--";
      }
      return formatSeconds(time);
    },
  },
  components: {
    LoginUser,
    Richtext,
  },
};
</script>

<style lang="scss" scoped>
.page-virtual-home {
  ::v-deep {
    .ul-page__body {
      background-color: #f8f8f8;
    }
    .ul-page__body-content {
      width: 100%;
      background-color: #f8f8f8;
    }
  }
}
.page-top {
  background-image: url("~@/assets/images/virtual/virtual_home_banner.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  .page-top-shadow {
    padding-top: 32px;
  }
  .content {
    @include page-width;
    display: flex;
    padding: 24px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, #fff 100%);
  }
  .course-study {
    @include page-width;
    padding: 16px 24px;
    margin: 20px auto;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .course-study-left {
      display: flex;
      align-items: center;
      img {
        width: 106px;
        height: 60px;
        margin-right: 16px;
      }
      .course-study-info {
        padding-right: 16px;
        .name {
          margin-bottom: 10px;
          font-size: 16px;
          display: flex;
          align-items: center;
          .courseName {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .tag {
            display: block;
            min-width: max-content;
            padding: 2px 4px;
            color: #4faaff;
            font-size: 12px;
            border-radius: 2px;
            border: 1px solid #c5e2fc;
            background: #e8f4ff;
            margin-right: 8px;
          }
        }
        .tea {
          color: #969696;
          > span {
            margin-right: 20px;
          }
        }
      }
    }
  }
  .cover {
    font-size: 0;
    img {
      height: 238px;
      width: 423px;
      box-sizing: border-box;
    }
  }
  .detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 28px;
    .title {
      font-size: 24px;
      line-height: 30px;
      font-weight: 600;
      @include ellipsis2;
      margin-bottom: 14px;
    }
    .teacher {
      font-size: 14px;
      line-height: 20px;
      color: #969696;
      margin-top: 10px;
      > span {
        margin-right: 32px;
      }
    }
  }
  .info-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 24px;
    @media (max-width: 1200px) {
      li:last-child {
        margin-top: 12px;
      }
    }
    li {
      margin-right: 36px;
    }
    .value {
      font-size: 24px;
      font-weight: 600;
      line-height: 24px;
    }
    .label {
      display: flex;
      align-items: center;
      margin-top: 12px;
      line-height: 1;
      color: #969696;
      i {
        margin-right: 4px;
        font-size: 14px;
      }
    }
  }
  .bt-wrapper {
    flex: 1;
    display: flex;
    align-items: flex-end;
    margin-top: 20px;
  }
}
.main-content {
  @include page-width;
  padding: 10px 0;
  background-color: #fff;
  margin: 0px auto 80px;
}
.tabs-wrapper {
  display: flex;
  justify-content: center;
  border-bottom: $--border-base;
}
.tabs {
  display: flex;
  .tab {
    padding: 10px 0;
    margin: 0 20px;
    line-height: 24px;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      color: $--color-primary;
    }
    &.is-active {
      border-bottom: solid 3px $--color-primary;
      color: $--color-primary;
    }
  }
}
.tab-content {
  padding: 24px;
  .virtual-item {
    margin-bottom: 40px;
    &:last-child {
      margin-bottom: 0;
    }
    .title {
      border-left: 3px solid #ea5947;
      padding-left: 8px;
      font-size: 18px;
      font-weight: 600;
      line-height: 1;
      margin-bottom: 16px;
    }
  }
}
</style>